export default {
  relatedTitle: 'Illustrazioni Correlate',
};
